// extracted by mini-css-extract-plugin
export var animationContainer = "_ms-0";
export var footer = "_ms-1";
export var gray = "_ms-2";
export var lineItem = "_ms-3";
export var lineItemImage = "_ms-4";
export var lineItemInfo = "_ms-5";
export var lineItemText = "_ms-6";
export var lineItems = "_ms-7";
export var modalContent = "_ms-8";
export var options = "_ms-9";
export var orderName = "_ms-a";
export var refundAmount = "_ms-b";